import { useEffect, useState } from 'react';
import APIService from 'services/APIService';
import { IUserSettings } from 'interfaces';
import { initUserId } from 'utils/piwikUtils';

const WHITELISTED_QA_EMAILS = [
    '@geoquant.com',
    '@fitchgroup.co',
    '@fitchsolutions.com',
    '@fitchgroup.com',
    '@thefitchgroup.com',
    '@bmigeorisksignals.com',
];

const WHITELISTED_QA_USERNAMES = [
    'andshe'
];

const isWhitelistedQAUser = (username: string) => {
    return WHITELISTED_QA_EMAILS.some(email => username.includes(email)) || WHITELISTED_QA_USERNAMES.includes(username);
}

export const usePingAuth = () => {
    const [didPing, setDidPing] = useState(false);
    const [hasGQPermissions, setHasGQPermissions] = useState(false);
    const [hasQAPermissions, setHasQAPermissions] = useState(false);
    const pingAuth = async () => {
        const response: IUserSettings = await APIService.me();
        initUserId(response.webUserId)
        setHasGQPermissions(!!response.permissions);
        setHasQAPermissions(!!isWhitelistedQAUser(response.username || ''));
        setDidPing(true);  
    };
    useEffect(() => {
        pingAuth();
    }, []);
    return { didPing, hasGQPermissions, hasQAPermissions };
};
